export const GENERAL_ERRORS = {
  HARDWARE_FIRMWARE_ERROR: 'Not supported hardware firmware',
  HARDWARE_NOT_RESPONDING_ERROR: "Hardware connected but doesn't respond",
};

export const AUTOSAMPLER_ERRORS = {
  /* AlltestaAutosampler */
  SYRINGE_ERROR: 'Syringe error',
  SYRINGE_CALIBRATION: 'Syringe calibration',
  SYRINGE_GENERAL_ERROR: 'Unknown plunger position and not moving',
  SYRINGE_NOT_INSTALLED: 'Syringe not installed',
  NEEDLE_ERROR: 'Needle error',
  NEEDLE_CALIBRATION: 'Needle calibration',
  NEEDLE_GENERAL_ERROR: 'Needle position unknown',
  VALVE_ERROR: 'Valve error',
  VALVE_CALIBRATION: 'Valve calibration',
  VALVE_GENERAL_ERROR: 'Valve position unknown',
  VALVE_NOT_INSTALLED: 'Valve not installed',
  TRAY_ERROR: 'Tray error',
  TRAY_CALIBRATION: 'Tray calibration',
  TRAY_GENERAL_ERROR: 'Tray position unknown',
  ARM_ERROR: 'Arm error',
  ARM_CALIBRATION: 'Arm calibration',
  ARM_GENERAL_ERROR: 'Arm position unknown',
  ALL_BLOCK_ERROR: 'All block error',
  VIAL_GENERAL_ERROR: 'Vial positioning error',
  VIAL_PRESENCE_GENERAL_ERROR: 'Vial sensor board is not installed',
  VIAL_PRESENCE_NEEDLE_ERROR: 'Needle Error',
  VIAL_PRESENCE_ARM_ERROR: 'Arm Error',
  VIAL_PRESENCE_TRAY_ERROR: 'Tray Error',
  VIAL_PRESENCE_BOARD_TIMEOUT_ERROR: 'Vial sensor board timeout',
  /* Fake Autosampler */
  TRAY_ROTATION: 'Tray rotation error',
  ARM_ROTATION_BLOCKED: 'Arm rotation blocked',
  ARM_ELEVATION_BLOCKED: 'Arm elevation blocked',
};

export const PUMP_ERRORS = {
  GENERAL_ERROR: 'General error',
  OVERPRESSURE: 'Overpressure',
  PRESSURE_UNAVAILABLE: 'Pressure unavailable',
};
